export enum EProductKind {
    Physical = 1,
    Digital,
    Service,
    Subscription,
}
